export const courseProgressUrl = (courseId: string | number) => `/courses/${courseId}/progress`;
export const coursesTotalProgressUrl = () => `/courses/total_progress`;
export const coursesArchivedUrl = () => `/courses/archived`;
export const coursesActiveUrl = () => `/courses/active`;
export const coursesLatestUrl = () => `/courses/latest`;
export const coursesNewUrl = () => `/courses/new`;
export const coursesUrl = () => `/courses`;
export const courseUrl = (courseId: string | number) => `/courses/${courseId}`;
export const courseKeyDatesUrl = (courseId: string | number) => `/courses/${courseId}/key_dates`;
export const courseKeyDateUrl = (courseId: string | number, keyDateId: string | number) => `/courses/${courseId}/key_dates/${keyDateId}`;
export const courseRoadMapUrl = (courseId: string | number) => `/courses/${courseId}/road_map`;
export const courseFilesUrl = (courseId: string | number) => `/courses/${courseId}/files`;
export const unitsUrl = (courseId: string | number) => `/courses/${courseId}/units`;
export const unitUrl = (courseId: string | number, unitId: string | number) => `/courses/${courseId}/units/${unitId}`;
export const subUnitsUrl = (courseId: string | number, unitId: string | number) => `/courses/${courseId}/units/${unitId}/sub_units`;
export const subUnitUrl = (courseId: string | number, unitId: string | number, subUnitId: string | number) => `/courses/${courseId}/units/${unitId}/sub_units/${subUnitId}`;


// Material Progress Endpoints
export const materialCompleteUrl = (materialId: string | number) => `/materials/${materialId}/complete`;
export const materialInProgressUrl = (materialId: string | number) => `/materials/${materialId}/in_progress`;

// Smart Notes
export const smartNoteUrl = (id: string | number) => `/smart_notes/${id}`;
export const smartNoteExpandUrl = (id: string | number) => `/smart_notes/${id}/expand`;

// Quizzes
export const quizzesUrl = () => `/quizzes`;
export const aiQuizzesUrl = (materialId?: string | number) => {
  let url = `/ai/quizzes`;
  if (materialId) {
    url += `?material_id=${materialId}`;
  }
  return url;
};
export const aiPromptQuizzesUrl = () => '/ai/prompt_quizzes';
export const quizUrl = (id: string | number) => `/quizzes/${id}`;
export const quizCompleteUrl = (id: string | number) => `/quizzes/${id}/complete`;
export const quizRegenerateUrl = (id: string | number) => `/quizzes/${id}/regenerate`;
export const questionResultUrl = () => `/question_results/`;

// Games
export const aiGameUrl = (id: string | number) => `/ai/games/${id}`;
export const aiGameGenerateMoreQuestionsUrl = (id: string | number) => `/ai/games/${id}/generate_more_questions`;
export const aiGameQuestionsUrl = (id: string | number) => `/ai/games/${id}/questions`;

// Card Sets
export const cardSetSlidesUrl = (id: string | number, format?: string) => `/card_sets/${id}/slides${format ? `.${format}` : ''}`;

// Practice
export const practiceUrl = () => `/practices`;
export const practiceShowUrl = (id: string | number) => `/practices/${id}`;

// Chat
export const chatUrl = () => '/chat';

// Profile
export const profileUpdateUrl = () => '/profile';

// Users
export const userUrl = (id: string | number) => `/users/${id}`;
export const userChangePasswordUrl = () => '/users/change_password';

// Email
export const userChangeEmailUrl = () => '/users/emails';
export const emailVerificationVerifyUrl = () => '/users/emails/verify';

// Direct Uploads
export const directUploadUrl = () => '/rails/active_storage/direct_uploads';
export const uploadUrl = (id: string | number) => `/uploads/${id}`;

// Folders
export const foldersUrl = () => '/folders';
export const folderUrl = (id: string | number) => `/folders/${id}`;

// Notes
export const notesUrl = () => '/notes';
export const noteUrl = (id: string | number) => `/notes/${id}`;

// Lectures
export const newLecturePath = () => '/lectures/new';

export const newResolveUrl = (folderId?: string | number) => {
  const baseUrl = '/resolves/new';
  return folderId ? `${baseUrl}?folder_id=${folderId}` : baseUrl;
};

export const resolveNewUrl = (folderId?: string | number) => {
  const baseUrl = '/resolve_conversations/new';
  return folderId ? `${baseUrl}?folder_id=${folderId}` : baseUrl;
};

// Onboarding
export const onboardingUserUrl = () => '/onboardings/update_onboarding';

// User Settings
export const userSettingsUrl = () => '/preferences';

// Videos
export const videosUrl = () => '/smart_notes/generate_video';
export const videoUrl = (id: string | number) => `/videos/${id}`;

// Courses
export const courseMistakesUrl = (courseId: string | number) => `/courses/${courseId}/mistakes`;